import { ErrorBoundary } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { useRedirect, useRepositoryMetaTitle } from "../app/routing"
import { useTeamSpace } from "../app/services/role"
import { DocumentListBody } from "./DocumentListBody"
import {
  DocumentListBodySkeleton,
  renderDocumentListBodyError,
} from "./DocumentListBody/DocumentListBody"
import { DocumentListBodyLayout } from "./DocumentListBody/DocumentListBodyLayout"
import { DocumentListHeader } from "./DocumentListHeader/DocumentListHeader"
import { DocumentListLayout } from "./documentListLayout"
import { DocumentListSearchParamsProvider } from "./DocumentListSearchParamsProvider"
import { DocumentListSidePanel } from "./DocumentListSidePanel"
import { useDocumentListSearchParams } from "./useDocumentListSearchParams"

interface DocumentListProps {
  tab: "working" | "archived"
}

export function DocumentList(props: DocumentListProps) {
  const { tab } = props

  useRepositoryMetaTitle(tabToLabel[tab])

  return (
    <DocumentListSearchParamsProvider>
      <DocumentListLayout
        header={<DocumentListHeader tab={tab} />}
        body={
          <DocumentListBodyLayout>
            <ErrorBoundary renderError={renderDocumentListBodyError}>
              <Suspense fallback={<DocumentListBodySkeleton tab={tab} />}>
                <DocumentListPageBody tab={tab} />
              </Suspense>
            </ErrorBoundary>
          </DocumentListBodyLayout>
        }
        sidePanel={<DocumentListSidePanel selectedMenuItem="main-space" />}
      />
    </DocumentListSearchParamsProvider>
  )
}

const tabToLabel: Record<DocumentListProps["tab"], string> = {
  working: "Work",
  archived: "Archived",
}

interface DocumentListPageBodyProps {
  tab: DocumentListProps["tab"]
}

function DocumentListPageBody(props: DocumentListPageBodyProps) {
  const { tab } = props

  const { optimisticSearchParams } = useDocumentListSearchParams()
  const teamSpaceId = optimisticSearchParams.space
  const teamSpace = useTeamSpace(teamSpaceId)

  const redirect = useRedirect(teamSpace === undefined, {
    to: `/${tab}`,
    title: "Space not found",
    subtitle: `The Space might have been deleted.\nYou have been redirected to the Main Space.`,
  })
  if (redirect) return null

  return <DocumentListBody tab={tab} />
}
